export const MANAGER_BATCH_STATUS_DISPLAY = {
  pending: { cls: 'cr-badge-warning', text: 'Pending Review' },
  recalled: {
    cls: 'cr-badge-muted',
    text: 'Recalled',
    title: 'Awaiting resubmission from site'
  },
  rejected: { cls: 'cr-badge-danger', text: 'Rejected' },
  completed: { cls: 'cr-badge-success', text: 'Completed' },
  mixed: { cls: 'cr-badge-muted', text: 'Mixed Status' }
};

export function managerBatchStatusDisplay(status) {
  if (!status) return MANAGER_BATCH_STATUS_DISPLAY.pending;
  return MANAGER_BATCH_STATUS_DISPLAY[status] || {
    cls: 'cr-badge-muted',
    text: 'Unknown'
  };
}

export function isManagerBatchReviewable(status) {
  return status === 'pending' || !status;
}

export function isRefreshableReviewConflict(error) {
  const response = error && error.response;
  const data = (response && response.data) || error || {};
  const status = (response && response.status) || error?.status || data.status || null;
  const code = data.code || error?.code || null;
  const message = [data.userMessage, data.error, data.message, error?.message]
    .filter((value) => typeof value === 'string')
    .join(' ');
  return (
    code === 'COUNT_RECALLED' ||
    code === 'COUNT_NOT_REVIEWABLE' ||
    status === 409 ||
    status === 404 ||
    /conflicts with the current state/i.test(message) ||
    /refresh and try again/i.test(message)
  );
}

export function isManagerReviewabilityError(error) {
  return isRefreshableReviewConflict(error);
}

export function refreshManagerDashboard() {
  window.location.reload();
}

export function managerSiteSubmissionStatus(batches, siteId) {
  const siteBatches = (batches || []).filter(
    (batch) => String(batch.siteId) === String(siteId)
  );
  if (siteBatches.some((batch) => isManagerBatchReviewable(batch.status))) {
    return 'Pending Review';
  }
  if (siteBatches.some((batch) => batch.status === 'recalled')) {
    return 'Recalled';
  }
  if (siteBatches.some((batch) => batch.status === 'completed')) {
    return 'Submitted';
  }
  return 'Not Submitted';
}
